export enum AdminUI {
  LOGIN,
  ALL_TERMINALS,
  TERMINAL,
  ERROR,
}
